import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";

export default function Home() {
  /* ================= HERO SLIDER ================= */
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  // Fetch hero images
  useEffect(() => {
    fetch(`${BASE_URL}/api/gethero.php`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Hero Data:", data);
        setSlides(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error(err));
  }, []);

  // Auto slide (ONLY ONE interval)
  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides]);

  // Reset index when slides change
  useEffect(() => {
    setCurrent(0);
  }, [slides]);

  /* ================= HOLIDAYS ================= */
  const [holidays, setHolidays] = useState([]);

  useEffect(() => {
    const fetchHolidays = () => {
      fetch(`${BASE_URL}/api/getHolidays.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setHolidays(Array.isArray(data) ? data : []))
        .catch((err) => console.error(err));
    };

    fetchHolidays();
    const interval = setInterval(fetchHolidays, 5000);

    return () => clearInterval(interval);
  }, []);

  /* ================= NEWS ================= */
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    const fetchNews = () => {
      fetch(`${BASE_URL}/api/getNews.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setNewsList(Array.isArray(data) ? data : []))
        .catch((err) => console.error(err));
    };

    fetchNews();
    const interval = setInterval(fetchNews, 5000);

    return () => clearInterval(interval);
  }, []);

  /* ================= UI STATE ================= */
  const [activePlan, setActivePlan] = useState("bachat");

  /* ================= RETURN ================= */
  return (
    <>
      {/* HERO */}
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-content">
          {/* LEFT CONTENT */}
          <div className="hero-left">
            <span className="hero-badge">મહિલા ક્રેડિટ કો-ઓપરેટીવ સોસાયટી</span>

            <h1 className="hero-title">
              શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર
              સોસાયટી લિ. માં તમારું સ્વાગત છે
            </h1>

            <p className="hero-description">
              સમગ્ર સુરત શહેર ના સભાસદ બહેનો ને જણાવતા અમો આનંદ અનુભવીએ છીએ કે,
              આ વિસ્તાર ની એકમાત્ર ૧0,000 સભાસદો ધરાવતી મહિલા ક્રેડિટ સોસાયટી
              માં સભાસદ થઇ નીચે મુજબ ની યોજનાઓ ના લાભ મેળવો..
            </p>

            <div className="hero-buttons">
              <button
                className="primary-btn"
                onClick={() => navigate("/about")}
              >
                વધુ જાણો
              </button>

              <button
                className="secondary-btn"
                onClick={() => navigate("/join")}
              >
                સંપર્ક કરો
              </button>
            </div>

            {/* STATS */}
            <div className="hero-stats">
              <div className="stat-box">
                <h3>૧૦,૦૦૦+</h3>
                <p>સભાસદો</p>
              </div>

              <div className="stat-box">
                <h3>૨૦+</h3>
                <p>વર્ષનો વિશ્વાસ</p>
              </div>

              <div className="stat-box">
                <h3>૧૦૦%</h3>
                <p>વિશ્વસનીય સેવા</p>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="hero-right">
            {slides.length > 0 && slides[current] && (
              <img
                src={`${BASE_URL}/uploads/${slides[current].image}`}
                alt="hero"
                className="hero-image"
              />
            )}

            {/* Floating Card */}
          </div>
        </div>
      </section>
      {/* WELCOME */}

      {/* NEWS */}
      <div className="news-section">
        <h2>તાજી માહિતી</h2>

        <div className="news-container">
          {newsList.length === 0 ? (
            <p>કોઈ માહિતી નથી</p>
          ) : (
            newsList.map((news) => (
              <div className="news-card" key={news.id}>
                <span className="news-date">{news.date}</span>
                <h4>{news.title}</h4>
                <p>{news.description}</p>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="head">
        <h2>સોસાયટી માં શેર સભાસદ બનો અને વિવિધ યોજના ઓ નો લાભ મેળવો</h2>
      </div>

      <div className="membership-title">
        <h2>શેર સભાસદ થવા માટે</h2>{" "}
      </div>
      <div className="membership-section">
        {/* ================================= */}
        {/* FIRST : VIMA SATHE */}
        {/* ================================= */}

        {/* ================================= */}
        {/* SECOND : VIMA VAGAR */}
        {/* ================================= */}

        <div className="membership-left">
          <div className="membership-badge">PREMIUM MEMBERSHIP</div>

          <h3>વીમા સાથે</h3>

          <p>વીમા યોજના સાથે સભ્યપદ મેળવી વધુ સુરક્ષા અને વિશેષ લાભ મેળવો.</p>
          <div className="membership-row">
            <div className="membership-right">
              <div className="member-card">
                <h4>સભાસદ ફી</h4>

                <table className="member-table">
                  <tr>
                    <td>ફરિજયાત બચત</td>
                    <td>૩૦૦૦/-</td>
                  </tr>

                  <tr>
                    <td>શેર</td>
                    <td>૫૦૦/-</td>
                  </tr>

                  <tr>
                    <td>વહીવટી ફાળો</td>
                    <td>૨૦૦/-</td>
                  </tr>

                  <tr>
                    <td>બિલ્ડીંગ ફંડ</td>
                    <td>૧૦૦/-</td>
                  </tr>

                  <tr>
                    <td>વીમા યોજના એન્ટ્રી ફ્રી</td>
                    <td>૫૦૦૦/-</td>
                  </tr>

                  <tr>
                    <td>સ્ટેશનરી ચાર્જ</td>
                    <td>૪૦/-</td>
                  </tr>

                  <tr>
                    <td>પ્રવેશ ફી</td>
                    <td>૪૦/-</td>
                  </tr>

                  <tr>
                    <td>ફોર્મ ફી</td>
                    <td>૧૦/-</td>
                  </tr>

                  <tr className="total-row">
                    <td>કુલ</td>
                    <td>૮૮૬૦/-</td>
                  </tr>
                </table>
              </div>

              <div className="member-card">
                <div className="row">
                  <h4>જરૂરી ડોક્યુમેન્ટસ</h4>
                  <div className="col-md-5">
                    <ul className="member-list">
                      <li>4 ફોટા</li>
                      <li>આધાર કાર્ડ</li>
                      <li>પાનકાર્ડ</li>
                      <li>ચૂંટણી કાર્ડ</li>

                      <li>બેંક પાસબુક</li>
                    </ul>
                  </div>

                  <div className="col-md-7">
                    <ul className="member-list">
                      <li>લાઈટબીલ (ભાડુઆત હોય તો)</li>
                      <li>વેરાબીલ રસીદ ફરજીયાત</li>

                      <li>સ્કૂલ એલ. સી. / દાખલો</li>
                    </ul>
                  </div>
                </div>

                <div className="row">
                  <h5>:: વારસદાર ::</h5>
                  <div className="col-md-5">
                    <ul className="member-list">
                      <li>1 ફોટો</li>
                      <li>આધારકાર્ડ</li>
                      <li>પાનકાર્ડ</li>
                    </ul>
                  </div>
                  <div className="col-md-7">
                    <ul className="member-list">
                      <li>ચૂંટણીકાર્ડ</li>
                      <li>બેંક પાસબુક ની ઝેરોક્ષ</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="membership-left">
          <div className="membership-badge">BASIC MEMBERSHIP</div>

          <h3>વીમા વગર</h3>

          <p>
            સામાન્ય સભ્યપદ યોજના જેમાં મૂળભૂત લાભ અને શેર સભ્યપદ સુવિધા મળે છે.
          </p>
          <div className="membership-row">
            <div className="membership-right">
              <div className="member-card">
                <h4>સભાસદ ફી</h4>

                <table className="member-table">
                  <tr>
                    <td>ફરિજયાત બચત</td>
                    <td>૩૦૦૦/-</td>
                  </tr>

                  <tr>
                    <td>શેર</td>
                    <td>૫૦૦/-</td>
                  </tr>

                  <tr>
                    <td>વહીવટી ફાળો</td>
                    <td>૨૦૦/-</td>
                  </tr>

                  <tr>
                    <td>બિલ્ડીંગ ફંડ</td>
                    <td>૧૦૦/-</td>
                  </tr>

                  <tr>
                    <td>સ્ટેશનરી ચાર્જ</td>
                    <td>૪૦/-</td>
                  </tr>

                  <tr>
                    <td>પ્રવેશ ફી</td>
                    <td>૪૦/-</td>
                  </tr>

                  <tr>
                    <td>ફોર્મ ફી</td>
                    <td>૧૦/-</td>
                  </tr>

                  <tr className="total-row">
                    <td>કુલ</td>
                    <td>૧૮૬૦/-</td>
                  </tr>
                </table>
              </div>

              <div className="member-card">
                <h4>જરૂરી ડોક્યુમેન્ટસ</h4>

                <ul className="member-list">
                  <li>2 ફોટા</li>
                  <li>આધાર કાર્ડ</li>
                  <li>પાનકાર્ડ</li>
                  <li>ચૂંટણી કાર્ડ</li>
                  <li>લાઈટબીલ (ભાડુઆત હોય તો )</li>
                  <li>વેરાબીલ રસીદ </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="membership-left1">
        {" "}
        <div className="row" style={{ margin: "10px" }}>
          <div className="col-md-3 box1">
            <h4 className="text-center">
              દર વર્ષે સભાસદો બહેનોનાં બાળકોને ઇનામ વિતરણ
            </h4>
          </div>
          <div className="col-md-3 box1">
            {" "}
            <h4 className="text-center">
              દર વર્ષે સભાસદો બહેનોને ફુલસ્કેપ ચોપડા તથા આકર્ષક ગીફ્ટ
            </h4>
          </div>
          <div className="col-md-5 box1">
            {" "}
            <h4 className="text-center">
              જુના તથા નવા સભાસદે દર વર્ષે તા. ૧ એપ્રિલ થી ફરજીયાત બચત ના ₹
              ૧૦૦૦/- ફરજીયાત ભરી પોતાની ફ્રી ગીફ્ટ મેળવી લેવી.
            </h4>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      {/* DETAIL SECTION */}

      <div className="plan-detail">
        <div className="membership-title">
          <h2 style={{ marginBottom: "40px" }}>અમારી સેવાઓ</h2>
        </div>

        <div className="zigzag-wrapper">
          {/* ===================== BACHAT ===================== */}

          <div className="zigzag-row reverse">
            <div className="zigzag-image">
              {/* <img src="bachat-yojana-banner.png" alt="" /> */}
              <img src="images/bachat.webp" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Saving Plan</div>

              <h2>બચત યોજના</h2>

              <p>નિયમિત બચત કરીને ભવિષ્યને વધુ સુરક્ષિત અને મજબૂત બનાવો.</p>

              <div className="plan-grid">
                {/* BOX 1 */}
                <div className="plan-box">
                  <h2>બચત યોજના વિગત</h2>
                  <p>
                    ₹૧00/- કે ₹૧00/- ના ગુણાંક માં ગમે તેટલી રકમ માટે 1 વર્ષ ની
                    મુદત માટે ખાતું ખોલાવી શકાય છે.
                  </p>
                  <ul>
                    <li>
                      ₹૫00 /- નાં ૧૨ માસ મુજબ ₹૬૨૫0/- (સ્ટીલ ડબ્બી નંગ - ૧ )
                    </li>
                    <li>
                      ₹૧000/- નાં ૧૨ માસ મુજબ ₹૧૨૫00/- (સ્ટીલ ડબ્બો નંગ - ૧ )
                    </li>
                    <li>
                      ₹૨000/- નાં ૧૨ માસ મુજબ ₹૨૫000/- (સ્ટીલ બોઘરી નંગ - ૧ )
                    </li>
                    <li>
                      ₹૫000/- નાં ૧૨ માસ મુજબ ₹૬૨૫00/- (સ્ટીલ પુરી ડબ્બો /
                      નોનસ્ટીક તવો)
                    </li>
                  </ul>
                  <br></br>
                  <h2>અન્ય બચત યોજનાઓ</h2>
                  <p>બચત દ્વારા ભવિષ્ય સુરક્ષિત બનાવો.</p>
                  <ul>
                    <li>સામાન્ય બચત ૩.૫% વ્યાજ નો દર</li>
                    <li>ફરજીયાત બચત ૩.૫% વ્યાજ નો દર</li>
                    <li> ડેઇલી રીકરીંગ ૪.૫% વ્યાજ નો દર</li>
                  </ul>
                </div>

                {/* BOX 2 */}
              </div>
            </div>
          </div>

          {/* ===================== LOAN ===================== */}

          <div className="zigzag-row">
            <div className="zigzag-image">
              <img src="/images/fd2.png" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Fixed Deposit</div>

              <h2>ફિક્સ ડિપોઝિટ યોજના</h2>
              <div className="row">
                <div className="col-md-7 plan-box">
                  {" "}
                  <ul className="zigzag-list" style={{ paddingTop: "20px" }}>
                    <li>૧ વર્ષ માટે ૭.૫%</li>

                    <li>૨ વર્ષ માટે ૮.૫%</li>

                    <li>૩ વર્ષ માટે ૯.૫%</li>

                    <li>૮ વર્ષે બમણા</li>
                  </ul>
                </div>
                <div className="col-md-4 round" style={{ margin: "0px" }}>
                  <h4 className="text-center">
                    સીનીયર સીટીઝન (વડીલો) માટે 0.૫0% વધારે વ્યાજ
                  </h4>
                </div>
              </div>
              <ul className="zigzag-list">
                <h4 style={{ marginTop: "0px" }}>:: ૮ વર્ષે બમણા ::</h4>

                <li>₹૫,000 ની F.D. ઉપર સ્ટીલ નાનો ડબ્બો નંગ -૧</li>

                <li>₹૧0,000 ની F.D. ઉપર સ્ટીલ ડબ્બો નંગ -૧</li>

                <li>₹૨૫,000 ની F.D. ઉપર સ્ટીલ કાથરોટ નંગ -૧</li>

                <li>₹૫0,000 ની F.D. ઉપર સ્ટીલ પવાલી અથવા સ્ટીલ કઢાઈ નંગ -૧</li>
              </ul>
              <div className="zigzag-note">
                ₹૧૫,000/- કે તેથી વધુ રકમ ની ફિક્સ ડિપોઝિટ ત્રણ વર્ષ માટે મુકનાર
                ને ફ્રી ગીફ્ટ નો લાભ મળશે.
              </div>
            </div>
          </div>
          {/* ===================== INSURANCE ===================== */}

          <div className="zigzag-row reverse">
            <div className="zigzag-image">
              <img src="/images/vima.jpg" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Insurance Plan</div>

              <h2> વીમા યોજના</h2>

              <h5
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#5e6572",
                }}
              >
                તા. ૦૧/૦૧/૨૦૨૫ થી ₹૨,00,000/- ની વીમા યોજના સંપૂર્ણ પણે ચાલુ થઇ
                ગયેલ છે.
              </h5>
              <h5
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#5e6572",
                }}
              >
                વીમો કરાવનાર સભાસદ ને ફ્રી ગીફ્ટ નો લાભ મળશે.
              </h5>
              <ul className="zigzag-list">
                <li>
                  ૧૮ થી ૫૫ વર્ષ સુધીનાં સભાપદ વીમા યોજનામાં જોડાઈ શકશે, તેમજ
                  જ્યાં સુધી સભાસદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો મળવા પાત્ર
                  છે.
                </li>
                <li>
                  વીમા યોજના માં જોડાનાર સભાસદે પ્રથમવાર વીમો કરાવતી વખતે ફક્ત
                  એક વખતે ₹૫000/- વીમા યોજના ફી ભરવાની રહેશે.જે કોઈપણ સંજોગો માં
                  મળવાપાત્ર નથી.
                </li>

                <li>
                  વીમો થયા બાદ જે તે સભાસદ ના ખાતામાંથી સભાસદ દીઠ કોઈપણ સભાસદ
                  નું મૃત્યુ થાય તે સમયે જે રકમ મંડળી દ્વારા નક્કી કરવામાં આવે
                  તે તેના ફરજીયાત રકમ ના ખાતા માંથી ઉધારવામાં આવશે.
                </li>

                <li>
                  વર્ષ દરમિયાન ફરજીયાત બચતના ખાતામાંથી વીમા સહાય માટે જે રકમ
                  કપાયેલી હોઈ તે દર વર્ષે એપ્રિલ માસમાં ફરજીયાત બચતની સાથે જ
                  ફરજીયાત ભરવાની રહેશે.{" "}
                </li>

                <li>
                  વીમાદર સભાસદની બચત + વીમા પેટે કપાયેલી રકમ જમા કરાવવાની બાકી
                  હશે તો તે સભાસદ નો વીમો માન્ય ગણાશે નહી.
                </li>

                <li>
                  વીમો લેનાર સભાસદ તેમની હયાતીમાં જ વારસદારના નામ માં ફેરફાર કરી
                  શકશે. તેના માટે ₹૧00/- ફી ચુકવવાની રહેશે.
                </li>

                <li>
                  સદર વીમાયોજના નો લાભ સભાસદનું કોઈપણ રીતે મૃત્યુ થાય (આત્મહત્યા
                  સીવાય ) તો જ ₹૨,00,000/- નું વળતર મળવાપાત્ર છે.
                </li>

                <li>
                  સભાસદનું મૃત્યુ થયાના ૯0 દિવસ બાદ વિમાની રકમ વારસદાર ને ચૂકવવા
                  માં આવશે.
                </li>

                <li>
                  મૃત્યુ સમયે સભાસદ કે તેના નોંધાયેલા વારસદારો સદર સંસ્થાના
                  કોઈપણ પ્રકારના બાકીદારહશે કે સંસ્થાનું લેણું બાકી હશે તો
                  વળતરની રકમ માંથી બાકી લેણાંની રકમ કાપીને પછીની રકમ ચૂકવવા માં
                  આવશે.
                </li>

                <li>
                  કોઈપણ લોન લેનાર સભાસદમાં જામીન થયેલા હશો, તે બાબત ક્લિયર ના
                  થાય ત્યાં સુધી પાકતી વિમાની રકમ અટકાવવામાં આવશે.
                </li>

                <li>
                  વીમાદાર વ્યક્તિ જે લોન લેનાર સભાસદમાં જામીન થેલા હશે, જે
                  રેગ્યુલર સભાસદ હશે તો યોગ્ય બાબત વિચારી યોગ્ય કરવામાં આવશે.
                </li>
              </ul>
            </div>
          </div>
          <div className="zigzag-row">
            <div className="zigzag-image">
              <img src="images/loan.jpg" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Loan Facility</div>

              <h2>લોન સુવિધા</h2>

              <ul className="zigzag-list">
                <li>પ્રથમ લોન ₹૫0,000/- મળશે.</li>

                <li>હવે ૨0% બચત ની જગ્યાએ માત્ર 10% બચત જમા કરાવવી રહેશે.</li>

                <li>
                  ભાડુઆત સભાસદો માટે ત્રણેય જમીન મિલકતવાળા આપીને ક્રમશ:
                  ₹૫0,000/- થી ₹૭૫,000/- (રેગ્યુલર હપ્તા હોય તો ) સુધી લોન મળશે.
                </li>

                <li>
                  ટૂંક સમય માટે ૬0 વર્ષ સુધી ના સભાસદ વીમા સાથે લેવાનું ચાલુ
                  કરેલ છે.
                </li>
              </ul>

              <div className="row">
                <div className="col-md-7 box">
                  {" "}
                  <ul className="zigzag-list">
                    <h4>સોસાયટી નાં શેર સભાસદ બની નીચે મુજબ ના લાભ મેળવો. </h4>

                    <li>રોકડ જાતજામીન ધીરાણ : ₹૨,00,000/- (બે લાખ) સુધી.</li>

                    <li>
                      વિવિધ પ્રકારના સાધન ધિરાણ : ₹૧0,00,000/- (દસ લાખ) સુધી.
                    </li>

                    <li>મોર્ગેજ ધિરાણ : ₹૧૫,00,000/- (પંદર લાખ)સુધી.</li>
                  </ul>
                </div>
                <div className="col-md-4 box">
                  {" "}
                  <h4>
                    ૪ ના ગ્રુપ માં સભાસદ બની તુરંત જ ₹૫0,000/- રોકડ ધિરાણ મેળવો.
                  </h4>
                </div>
              </div>
              <div className="zigzag-note">
                લોન નિયમિત ભરનાર ને નિયમો અનુસાર વ્યાજ રિબેટ આપવામાં આવશે.
              </div>

              <h4> </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="trust-section">
        <div className="trust-header">
          <span className="trust-tag">WHY CHOOSE US</span>

          <h2>અમને કેમ પસંદ કરશો?</h2>

          <p>
            વિશ્વાસ, સુરક્ષા અને પારદર્શક સેવાઓ સાથે મહિલાઓ માટે ખાસ બનાવેલ
            સહકારી સંસ્થા.
          </p>
        </div>

        {/* <div className="trust-wrapper">
       
          <div className="trust-item">
            <div className="trust-icon">
              <i className="bi bi-check-circle"></i>
            </div>

            <div className="trust-content">
              <h3>પારદર્શક વહીવટ</h3>

              <p>
                અમારી તમામ કામગીરી સંપૂર્ણ પારદર્શક અને કાયદેસરની પ્રક્રિયા મુજબ
                કરવામાં આવે છે જેથી દરેક સભ્ય વિશ્વાસ સાથે જોડાઈ શકે.
              </p>
            </div>

            <div className="trust-number">01</div>
          </div>

     
          <div className="trust-item">
            <div className="trust-icon">
              <i className="bi bi-people"></i>
            </div>

            <div className="trust-content">
              <h3>મહિલા સંચાલિત</h3>

              <p>
                મહિલાઓ દ્વારા સંચાલિત આ સંસ્થા મહિલાઓના વિકાસ અને આર્થિક
                સશક્તિકરણ માટે સતત કાર્યરત છે.
              </p>
            </div>

            <div className="trust-number">02</div>
          </div>

     
          <div className="trust-item">
            <div className="trust-icon">
              <i className="bi bi-lightning"></i>
            </div>

            <div className="trust-content">
              <h3>આકર્ષક વ્યાજ દર</h3>

              <p>
                થાપણો પર વધુ વ્યાજ અને લોન માટે વ્યાજબી દરો સાથે સભ્યોને વધુ લાભ
                આપવામાં આવે છે.
              </p>
            </div>

            <div className="trust-number">03</div>
          </div>


          <div className="trust-item">
            <div className="trust-icon">
              <i className="bi bi-shield-lock"></i>
            </div>

            <div className="trust-content">
              <h3>સરળ પ્રક્રિયા</h3>

              <p>
                ખાતું ખોલાવવું, લોન લેવી અથવા અન્ય સેવાઓ માટે ખૂબ સરળ અને ઝડપી
                પ્રક્રિયા ઉપલબ્ધ છે.
              </p>
            </div>

            <div className="trust-number">04</div>
          </div>
        </div> */}

        <div className="modern-container">
          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-check-circle"></i>
            </div>
            <h4>પારદર્શક વહીવટ</h4>
            <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>મહિલા સંચાલિત</h4>
            <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-lightning"></i>
            </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
            <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h4>સરળ પ્રક્રિયા</h4>
            <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>
        </div>
      </div>

      {/* HOLIDAYS */}
      <div className="holiday-section">
        <div className="holiday-top">
          <span className="holiday-tag">BANK HOLIDAYS</span>

          <h2>બેંક રજાઓ</h2>

          <p>
            સોસાયટી તથા બેંક ની મહત્વપૂર્ણ રજાઓ ની માહિતી અહીં આપવામાં આવેલ છે.
          </p>
        </div>

        <table className="holiday-table">
          <thead>
            <tr>
              <th>ક્રમ</th>
              <th>તારીખ</th>
              <th>રજાનું નામ</th>
            </tr>
          </thead>

          <tbody>
            {holidays.length === 0 ? (
              <tr>
                <td colSpan="3">કોઈ રજા નથી</td>
              </tr>
            ) : (
              holidays.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
